// extracted by mini-css-extract-plugin
module.exports = {"footerLink":"styles_footerLink__2d6Gh","pageFooter":"styles_pageFooter__1Gi3w","poweredByAuthing":"styles_poweredByAuthing__35lvs"};